import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ChartConfiguration, ChartType, Plugin } from "chart.js";
import { LanguageService } from 'src/app/service/language-service/language.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent  implements OnInit {
  isLoading:boolean = true;
  @Input() chartLabels: string[]; //espera input, ejemplo. ["Cumple", "En proceso", "No cumple"]
  @Input() chartData: number[]; //espera input, ejemplo [57, 14, 28]
  @Input() originalChartColors: string[]; //espera por ejemplo ["#0B740A", "#EBC53A", "#FF4560"]
  @Input() clickEventActive: boolean = false;

  @Output() chartClick: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  doughnutChartLabels: string[] = [];
  doughnutChartDatasets: ChartConfiguration['data']['datasets'] = [
		{
			data: [ ],
			backgroundColor: [
				'rgba(0, 227, 150, 1)',
				'rgba(255, 183, 0, 1)',
				'rgba(255, 69, 96, 1)'
			],
      circumference: 180,
      rotation: -90,
		},
	];

  doughnutChartOptions: ChartConfiguration['options'] = {
		responsive: true,
		aspectRatio: 2,
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'normal',
          size: 12
        },
        formatter: (value: any, context: any) => {
          const total = context.dataset.data.reduce((sum: number, val: number) => sum + val, 0);
          const percentage = ((value / total) * 100).toFixed(0);
          // const label = context.chart.data.labels[context.dataIndex];
          return Number(percentage) > 10 ? `${percentage}%` : '';
        },
        // Posicionar el texto en el centro de cada sección
        anchor: 'center',
        align: 'center'
      },
      legend: {
        display: false,
        // fullWidth: true,
        // maxWidth: 100,
        position: "bottom",
        align:'center',
        labels: {
          boxWidth: 15,
          usePointStyle: false,
          font: {
            size: 10
          },
        },
      },
      tooltip: {
        enabled: true
      }
    },
    onClick: (event, elements) => {
      if(this.clickEventActive && elements.length > 0) {
          const index = elements[0].index;
          const label = this.chartLabels[index];

          this.doughnutChartDatasets[0]['backgroundColor'] = this.originalChartColors.map((color, i) =>
            i === index ? color : color + "80" // agrega opacidad al resto (#RRGGBBAA)
          );
          this.chart?.update();
          this.chartClick.emit(label);
      }
    }
	};

  doughnutChartType: ChartType = "doughnut";
  doughnutChartPlugins: Plugin[] = [ChartDataLabels];

  arrayPercentages;
  language:string = "es";

  constructor(private languageService: LanguageService,) {

  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.doughnutChartDatasets[0]['data'] = this.chartData;
    this.doughnutChartDatasets[0]['backgroundColor'] = this.originalChartColors;
    this.isLoading = false;
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
      console.log(this.language)
    });
  }

  getOnlyNumbers(percentages ) {
    const numbers = percentages?.map(percentage => parseInt(percentage.replace("%", "")));
    return numbers;
  }

}
